import(/* webpackMode: "eager" */ "/codebuild/output/src2540224303/src/app/app/error.tsx");
